export const ID_STATUS_CREATED_ON_SKIN_REPORTER = '647605c463a4490a106c7cf8'